// The 'traversalBuilding' domain: building a traversal from a description.
export const TRAVERSAL_BUILDING_DOMAIN = 'traversalBuilding' as const;

export const traversalBuildingDomainDescription =
  'Building the dataset of a view — the specific components it starts from and the ' +
  'kinds of components it walks to — either new or as a change to a displayed dataset. ' +
  'When the user mentions a view in regard to its traversal, asks to edit a displayed ' +
  'dataset, or asks to visualize a set of components in a view, e.g. "make a view from ' +
  'Salesforce to the business capabilities it supports" or "visualize Salesforce, Workday ' +
  'and SAP in a view", delegate to handle_ui_command. In the instruction, restate the ' +
  "user's whole request exactly as the user wrote it. Requests to open an existing " +
  'viewpoint, requests ' +
  'for information about specific components, and requests for an explanation or ' +
  'analysis should be handled normally, without delegating. The UI-command specialist ' +
  'decides which actions are available this turn.';
